// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/debit-note-empty.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debit-page {
  --dn-bg: var(--bg-primary, #f4f7f7);
  --dn-surface: var(--surface-primary, #fff);
  --dn-soft: var(--surface-secondary, #f4f7f7);
  --dn-text: var(--text-primary, #142624);
  --dn-muted: var(--text-secondary, #506360);
  --dn-border: var(--border-subtle, #dce3e2);
  --dn-border-strong: var(--border-default, #cdd6d4);
  --dn-brand: var(--interactive-default, #0f766e);
  --dn-brand-soft: var(--interactive-soft, #f0f8f7);
  margin: 20px 8px 32px;
  min-width: 0;
  background: var(--dn-bg);
  color: var(--dn-text);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.global-dashboard-layout:has(.debit-page) {
  min-height: 100vh;
  background: var(--bg-primary, #f4f7f7);
}
.debit-page * {
  box-sizing: border-box;
}
.debit-page h1,
.debit-page h2,
.debit-page p {
  margin-top: 0;
}
.debit-page a {
  color: inherit;
}
.debit-page-heading {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 16px;
  row-gap: 16px;
  margin-bottom: 24px;
}
.debit-page-heading h1,
.debit-editor-title h1 {
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
}
.debit-page-heading p {
  margin: 4px 0 0;
  color: var(--dn-muted);
  font-size: 14px;
  line-height: 21.7px;
}
.debit-page-meta,
.debit-editor-title p {
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.debit-page-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.debit-page-meta {
  grid-column: 1 / -1;
}
.debit-primary-button.MuiButton-root,
.debit-secondary-button.MuiButton-root,
.debit-danger-button.MuiButton-root {
  display: inline-flex;
  min-width: 0;
  height: 40px;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border: 1px solid var(--dn-border-strong);
  border-radius: 10px;
  background: var(--dn-surface);
  color: var(--dn-text);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-style: normal;
  font-weight: var(--font-weight-medium, 500);
  line-height: normal;
  letter-spacing: 0;
  text-transform: none;
  box-shadow: none;
  white-space: nowrap;
}
.debit-primary-button.MuiButton-root {
  border-color: var(--dn-brand);
  background: var(--dn-brand);
  color: #fff;
}
.debit-primary-button.MuiButton-root:not(.Mui-disabled):hover {
  border-color: var(--interactive-hover, #0c5f59);
  background: var(--interactive-hover, #0c5f59);
  color: var(--on-interactive-primary, #fff);
  box-shadow: none;
}
.debit-secondary-button.MuiButton-root:not(.Mui-disabled):hover {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-soft-hover, #e4f2f0);
  color: var(--text-primary, #142624);
  box-shadow: none;
}
.debit-primary-button.MuiButton-root:not(.Mui-disabled):active {
  border-color: var(--interactive-pressed, #0a4a46);
  background: var(--interactive-pressed, #0a4a46);
}
.debit-primary-button .MuiCircularProgress-root,
.debit-secondary-button .MuiCircularProgress-root {
  color: currentColor;
}
.debit-primary-button.MuiButton-root:focus-visible,
.debit-secondary-button.MuiButton-root:focus-visible,
.debit-danger-button.MuiButton-root:focus-visible {
  outline: 2px solid var(--focus-ring, #41a89e);
  outline-offset: 2px;
}
.debit-danger-button.MuiButton-root {
  border-color: #b42318;
  color: #b42318;
}
.debit-danger-button.MuiButton-root:not(.Mui-disabled):hover {
  border-color: var(--danger-text, #b42318);
  background: var(--danger-soft, #fff1f0);
  color: var(--danger-text, #b42318);
}
.debit-primary-button svg,
.debit-secondary-button svg {
  width: 16px;
  height: 16px;
}
.debit-primary-button.Mui-disabled,
.debit-secondary-button.Mui-disabled {
  opacity: 0.48;
}
.debit-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}
.debit-search {
  display: flex;
  width: min(360px, 34%);
  height: 40px;
  flex: 0 0 min(360px, 34%);
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid var(--dn-border-strong);
  border-radius: 10px;
  background: var(--dn-surface);
  color: var(--dn-muted);
}
.debit-search svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
}
.debit-search input {
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--dn-text);
  font: 400 13px/20px var(--font-family-primary, "Lexend", sans-serif);
}
.debit-search input::placeholder {
  color: var(--dn-muted);
  opacity: 1;
}
.debit-search:focus-within {
  border-color: var(--dn-brand);
  box-shadow: none;
}
.debit-page .quotation-figma-dropdown-trigger:not(:disabled):focus-visible,
.debit-page
  .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger {
  border: 1px solid var(--dn-brand);
  box-shadow: none;
  outline: none;
}
.debit-page
  .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger {
  padding-inline: 12px 10px;
}
.debit-filter-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
.debit-filter {
  height: 40px;
  flex: 0 0 auto;
}
.debit-filter .quotation-figma-dropdown {
  height: 100%;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.debit-direction-filter {
  min-width: 130px;
  width: auto;
}
.debit-status-filter {
  min-width: 120px;
  width: auto;
}
.debit-date-filter {
  min-width: 150px;
  width: auto;
}
.debit-filter .quotation-figma-dropdown-trigger {
  height: 40px;
  border-color: var(--dn-border-strong);
  border-radius: 10px;
  background: var(--dn-surface);
  color: var(--dn-text);
  font-size: 13px;
}
.debit-filter .quotation-figma-dropdown-menu {
  z-index: 1300 !important;
  max-height: 240px;
  overflow-y: auto;
  border-color: var(--dn-border);
  background: var(--dn-surface);
}
.debit-filter .quotation-figma-dropdown-option {
  color: var(--dn-text);
  font-size: 13px;
}
.debit-filter .quotation-figma-dropdown-option:hover,
.debit-filter .quotation-figma-dropdown-option.is-selected {
  background: var(--dn-brand-soft);
  color: var(--dn-brand);
}
.debit-clear-filters,
.debit-link-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: 0;
  background: transparent;
  color: var(--dn-brand);
  font: 500 13px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.debit-clear-filters svg {
  width: 14px;
  height: 14px;
}
.debit-clear-filters:not(:disabled):hover,
.debit-link-button:not(:disabled):hover,
.debit-add-line:not(:disabled):hover {
  color: var(--interactive-hover, #0c5f59);
  text-decoration: underline;
  text-underline-offset: 3px;
}
.debit-register {
  overflow: hidden;
  border: 1px solid var(--dn-border);
  border-radius: 14px;
  background: var(--dn-surface);
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}
.debit-register-loading-summary,
.debit-register-loading-footer {
  display: flex;
  min-height: 36px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 16px;
  background: var(--dn-surface);
}
.debit-register-table-scroll {
  overflow-x: auto;
}
.debit-register-table {
  width: 100%;
  min-width: 920px;
  table-layout: fixed;
  border-collapse: collapse;
}
.debit-register-table th {
  height: 36px;
  padding: 0 8px;
  background: var(--dn-soft);
  color: var(--dn-muted);
  font-size: 11px;
  font-weight: 500;
  line-height: 14.3px;
  letter-spacing: 0.11px;
  text-align: left;
}
.debit-register-table th:first-child {
  width: 15%;
  padding-left: 16px;
}
.debit-register-table th:nth-child(2) {
  width: 9%;
}
.debit-register-table th:nth-child(3) {
  width: 16%;
}
.debit-register-table th:nth-child(4) {
  width: 13%;
}
.debit-register-table th:nth-child(5) {
  width: 13%;
}
.debit-register-table th:nth-child(6) {
  width: 10%;
}
.debit-register-table th:nth-child(7) {
  width: 7%;
}
.debit-register-table th:nth-child(8) {
  width: 10%;
}
.debit-register-table th:nth-child(9) {
  width: 7%;
}
.debit-register-table td {
  height: 64px;
  padding: 0 8px;
  border-bottom: 1px solid var(--dn-border);
}
.debit-register-table td:first-child {
  padding-left: 16px;
}
.debit-register-table .debit-register-amount {
  text-align: right;
}
.debit-register-table .debit-register-actions {
  text-align: center;
}
.debit-register-loading-footer {
  min-height: 52px;
  border-top: 1px solid var(--dn-border);
}
.debit-register-loading-footer > div {
  display: flex;
  gap: 8px;
}
.debit-empty {
  display: flex;
  min-height: 243px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 32px;
  text-align: center;
}
.debit-empty-icon {
  display: block;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  color: var(--dn-muted);
  background: currentColor;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / contain
    no-repeat;
}
.debit-empty h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 22.4px;
  letter-spacing: -0.08px;
}
.debit-empty p {
  max-width: 520px;
  margin: 0;
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 20.2px;
}
.debit-empty-action {
  margin-top: 0;
}
.debit-no-results {
  display: flex;
  min-height: 185px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  margin: 24px;
  padding: 16px;
  border: 1px solid var(--dn-border);
  border-radius: 10px;
  background: var(--dn-soft);
}
.debit-no-results h2 {
  margin: 0;
  color: var(--dn-muted);
  font-size: 13px;
  font-weight: 400;
  line-height: 20.2px;
}
.debit-no-results p {
  margin: 0;
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.debit-page .debit-guidance {
  margin: 24px 0 0;
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.debit-inline-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: -8px 0 16px;
  padding: 12px 16px;
  border: 1px solid var(--dn-border);
  border-radius: 10px;
  background: var(--dn-brand-soft);
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 18.2px;
}
.debit-inline-notice button {
  border: 0;
  background: transparent;
  color: var(--dn-text);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.debit-page.dark {
  --dn-bg: var(--bg-primary, #101113);
  --dn-surface: var(--surface-primary, #191b1f);
  --dn-soft: var(--surface-secondary, #22252a);
  --dn-text: var(--text-primary, #f2f3f5);
  --dn-muted: var(--text-secondary, #b3b8c2);
  --dn-border: var(--border-subtle, #2c3036);
  --dn-border-strong: var(--border-default, #3a3f47);
  --dn-brand: var(--interactive-default, #43a79c);
  --dn-brand-soft: var(--interactive-soft, #22252a);
}
.debit-page.dark .debit-primary-button.MuiButton-root {
  color: #10201e;
}
.debit-page.dark .debit-danger-button.MuiButton-root {
  color: #f97066;
}
.debit-page .quotation-figma-dropdown {
  position: relative;
}
.debit-page .quotation-figma-dropdown.is-open {
  z-index: 1300;
}
.debit-page .quotation-figma-dropdown-trigger {
  border-color: var(--dn-border-strong);
  border-radius: 10px;
  background: var(--dn-surface);
  color: var(--dn-text);
}
.debit-page .quotation-figma-dropdown-menu {
  z-index: 1300 !important;
  max-height: 240px;
  overflow-y: auto;
  border-color: var(--dn-border);
  background: var(--dn-surface);
}
.debit-page .quotation-figma-dropdown-option {
  color: var(--dn-text);
}
.debit-page .quotation-figma-dropdown-option:hover,
.debit-page .quotation-figma-dropdown-option.is-selected {
  background: var(--dn-brand-soft);
  color: var(--dn-brand);
}
.debit-breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: var(--dn-muted);
  font-size: 12px;
  line-height: 18px;
}
.debit-breadcrumbs svg {
  width: 14px;
  height: 14px;
}
.debit-breadcrumbs a {
  text-decoration: none;
}
.debit-breadcrumbs a:hover {
  color: var(--dn-brand);
}
.debit-breadcrumbs span {
  color: var(--dn-text);
  font-weight: 500;
}
.debit-editor-topbar {
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 0 32px;
  border-bottom: 1px solid var(--dn-border);
}
.debit-editor-title {
  margin-bottom: 20px;
}
.debit-editor-title h1 {
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.36px;
}
.debit-editor-title p {
  margin: 4px 0 0;
}
.debit-editor-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.debit-editor-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  align-items: start;
  gap: 0;
}
.debit-editor-form {
  min-width: 0;
  padding: 32px 24px 32px 32px;
}
.debit-form-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 0;
  border-bottom: 1px solid var(--dn-border);
}
.debit-form-section > label,
.debit-form-section > h2,
.debit-section-header h2,
.debit-notes-label h2 {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.debit-form-section input,
.debit-form-section select,
.debit-form-section textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid var(--dn-border-strong);
  border-radius: 10px;
  background: var(--dn-surface);
  color: var(--dn-text);
  font: 400 13px/20.2px var(--font-family-primary, "Lexend", sans-serif);
  outline: none;
}
.debit-form-section input,
.debit-form-section select {
  height: 40px;
  padding: 0 12px;
}
.debit-form-section textarea {
  min-height: 80px;
  padding: 12px;
  resize: vertical;
}
.debit-form-section input:focus,
.debit-form-section select:focus,
.debit-form-section textarea:focus {
  border-color: var(--dn-brand);
  box-shadow: none;
}
.debit-form-section input:disabled {
  background: transparent;
  color: var(--dn-muted);
  cursor: not-allowed;
}
.debit-source-select-wrap {
  position: relative;
  color: var(--dn-muted);
}
.debit-source-select-wrap > svg {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  width: 16px;
  height: 16px;
  pointer-events: none;
}
.debit-source-select .quotation-figma-dropdown-trigger {
  height: 40px;
  padding-left: 36px;
  border-color: var(--dn-border-strong);
  border-radius: 10px;
  background: var(--dn-surface);
  color: var(--dn-text);
  font: 400 13px/20.2px var(--font-family-primary, "Lexend", sans-serif);
}
.debit-source-select .quotation-figma-dropdown-trigger:disabled {
  background: var(--dn-soft);
  color: var(--dn-muted);
  opacity: 1;
}
.debit-source-select .quotation-figma-dropdown-menu {
  max-height: 224px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  border-color: var(--dn-border);
  background: var(--dn-surface);
}
.debit-source-select .quotation-figma-dropdown-menu::-webkit-scrollbar {
  width: 6px;
}
.debit-source-select .quotation-figma-dropdown-menu::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: var(--dn-border-strong);
}
.debit-selected-source {
  display: flex;
  min-height: 74px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 12px 16px;
  border: 1px solid var(--dn-border);
  border-radius: 10px;
  background: var(--dn-brand-soft);
}
.debit-selected-source > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}
.debit-selected-source > div:last-child {
  align-items: flex-end;
  text-align: right;
}
.debit-selected-source strong {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--dn-brand);
  font: 500 13px/18px var(--font-family-mono, "JetBrains Mono", monospace);
}
.debit-selected-source strong svg {
  width: 16px;
  height: 16px;
}
.debit-selected-source span {
  overflow: hidden;
  color: var(--dn-muted);
  font-size: 12px;
  line-height: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.debit-field-hint {
  margin: 0;
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.debit-field-error {
  color: #b42318;
  font-size: 11px;
  line-height: 16px;
}
.debit-page.dark .debit-field-error {
  color: #f97066;
}
.debit-source-unavailable,
.debit-info-note,
.debit-backend-notice,
.debit-backend-footer {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border: 1px solid #d8e3f0;
  border-radius: 10px;
  background: #eff6ff;
  color: #3f556c;
  font-size: 13px;
  line-height: 18.2px;
}
.debit-source-unavailable svg,
.debit-info-note svg,
.debit-backend-notice svg,
.debit-backend-footer svg {
  width: 15px;
  height: 15px;
  flex: 0 0 15px;
}
.debit-page.dark .debit-source-unavailable,
.debit-page.dark .debit-info-note,
.debit-page.dark .debit-backend-notice,
.debit-page.dark .debit-backend-footer {
  border-color: #2d3d50;
  background: #202d3d;
  color: #bcc9d8;
}
.debit-direction-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  padding: 3px;
  border: 1px solid var(--dn-border);
  border-radius: 10px;
  background: var(--dn-soft);
}
.debit-direction-toggle button {
  height: 36px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--dn-muted);
  font: 500 13px / normal var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.debit-direction-toggle button.is-active {
  background: var(--dn-brand);
  color: #fff;
}
.debit-page.dark .debit-direction-toggle button.is-active {
  color: #10201e;
}
.debit-section-hint {
  margin: 0;
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.debit-customer-direction-hint {
  display: none;
}
.debit-lines-section {
  gap: 12px;
}
.debit-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.debit-lines-title-mobile {
  display: none;
}
.debit-lines-table {
  overflow: visible;
  border: 1px solid var(--dn-border);
  border-radius: 10px;
  background: var(--dn-surface);
}
.debit-line-head,
.debit-line-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 72px 120px 120px 80px;
  align-items: center;
}
.debit-line-head {
  min-height: 32px;
  color: var(--dn-muted);
  font-size: 11px;
  font-weight: 500;
  line-height: 14.3px;
  letter-spacing: 0.11px;
}
.debit-line-head span {
  height: 32px;
  padding: 8px 12px;
}
.debit-line-head span:nth-child(3),
.debit-line-head span:nth-child(4) {
  text-align: right;
}
.debit-line-head span:last-child {
  text-align: center;
}
.debit-line-row {
  position: relative;
  min-height: 56px;
  border-top: 1px solid var(--dn-border);
  background: var(--dn-surface);
}
.debit-line-row:has(.quotation-figma-dropdown.is-open) {
  z-index: 1250;
}
.debit-line-row > label {
  display: flex;
  height: 56px;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 12px;
}
.debit-line-row > label > span,
.debit-line-total > span,
.debit-mobile-line-label {
  display: none;
}
.debit-line-row .debit-description {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  height: 56px;
  padding: 8px 12px;
}
.debit-line-row .debit-description input {
  flex: 1 1 auto;
  min-width: 0;
  height: 36px;
}
.debit-line-row .debit-description .quotation-figma-dropdown {
  flex: 0 0 152px;
  width: 152px;
}
.debit-line-row .debit-description .quotation-figma-dropdown-trigger {
  height: 36px;
  padding: 0 8px;
  border-radius: 6px;
  border-color: var(--dn-border);
  background: var(--dn-surface);
  color: var(--dn-text);
  font-size: 12px;
}
.debit-line-row .debit-description .quotation-figma-dropdown-trigger svg {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
}
.debit-line-row .debit-description .quotation-figma-dropdown-menu {
  z-index: 1300 !important;
  max-height: 200px;
  overflow-y: auto;
}
.debit-line-row .debit-quantity input,
.debit-line-row .debit-unit-amount input {
  height: 32px;
  padding: 0 8px;
  text-align: center;
}
.debit-line-row .debit-unit-amount input {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-weight: 500;
  text-align: right;
}
.debit-line-total {
  display: flex;
  height: 56px;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 12px;
  color: var(--dn-muted);
  font-size: 13px;
}
.debit-line-total strong {
  display: flex;
  width: 96px;
  height: 32px;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
  padding: 0 10px;
  border-radius: 10px;
  background: var(--dn-soft);
  color: var(--dn-muted);
  font: 500 16px/20.8px var(--font-family-mono, "JetBrains Mono", monospace);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.debit-remove-line {
  display: grid;
  width: 32px;
  height: 32px;
  justify-self: center;
  place-items: center;
  border: 1px solid var(--dn-border);
  border-radius: 10px;
  background: var(--dn-surface);
  color: var(--dn-muted);
  cursor: pointer;
}
.debit-remove-line:hover {
  border-color: #d92d20;
  color: #d92d20;
}
.debit-remove-line:disabled {
  border-color: var(--dn-border);
  background: var(--dn-soft);
  color: var(--dn-muted);
  cursor: not-allowed;
  opacity: 0.48;
}
.debit-remove-line svg {
  width: 15px;
  height: 15px;
}
.debit-remove-icon-mobile {
  display: none;
}
.debit-line-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 12px;
  border: 1px solid var(--dn-border);
  border-radius: 10px;
  background: var(--dn-surface);
  font-size: 12px;
  font-weight: 500;
  line-height: 15.6px;
  letter-spacing: 0.12px;
  color: var(--dn-muted);
}
.debit-line-total-row strong {
  color: var(--dn-text);
  font: 500 16px/20.8px var(--font-family-mono, "JetBrains Mono", monospace);
}
.debit-add-line {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
  padding: 8px 4px;
  border: 0;
  background: transparent;
  color: var(--dn-brand);
  font: 500 12px/15.6px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.12px;
  cursor: pointer;
}
.debit-add-line svg {
  width: 14px;
  height: 14px;
}
.debit-add-line:focus-visible,
.debit-clear-filters:focus-visible,
.debit-link-button:focus-visible {
  outline: 2px solid var(--focus-ring, #41a89e);
  outline-offset: 2px;
  border-radius: var(--radius-sm, 6px);
}
.debit-notes-label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.debit-notes-label > span {
  padding: 2px 6px;
  border-radius: 999px;
  background: var(--surface-tertiary, #e8edec);
  color: var(--dn-muted);
  font-size: 11px;
  line-height: 15.4px;
  letter-spacing: 0.11px;
}
.debit-preview {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  gap: 20px;
  padding: 32px 24px;
  border-left: 1px solid var(--dn-border);
  background: var(--dn-soft);
}
.debit-preview h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
}
.debit-preview > p {
  margin: -16px 0 0;
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.debit-preview-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px solid var(--dn-border);
  border-radius: 10px;
  background: var(--dn-surface);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}
.debit-preview-card strong {
  color: var(--dn-brand);
  font: 500 14px/18.2px var(--font-family-mono, "JetBrains Mono", monospace);
  letter-spacing: 0.28px;
}
.debit-preview-card span {
  color: var(--dn-muted);
}
.debit-preview-source-card strong {
  display: flex;
  align-items: center;
  gap: 6px;
}
.debit-preview-source-card strong svg {
  width: 16px;
  height: 16px;
}
.debit-preview-source-card b {
  color: var(--dn-text);
  font-size: 13px;
  font-weight: 500;
  line-height: 18.2px;
}
.debit-preview-breakdown {
  gap: 12px;
}
.debit-preview-breakdown > div {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.debit-preview-breakdown > div > strong {
  flex: 0 0 auto;
  color: var(--dn-text);
  font-size: 13px;
}
.debit-preview-breakdown hr {
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid var(--dn-border);
}
.debit-preview-breakdown .debit-preview-projected {
  flex-direction: column;
  gap: 4px;
}
.debit-preview-breakdown .debit-preview-projected strong {
  color: var(--dn-brand);
  font-size: 16px;
  line-height: 21px;
}
.debit-preview-callout {
  flex-direction: row;
  align-items: flex-start;
  color: var(--dn-muted);
}
.debit-preview-callout svg {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
}
.debit-preview-responsive {
  display: none;
}
.debit-tablet-direction-title {
  display: none;
}
.debit-editor-footer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 0;
}
.debit-editor-footer > p {
  margin: 0;
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.debit-backend-notice {
  position: relative;
  margin: 0 0 16px;
  padding-right: 38px;
}
.debit-backend-notice button {
  position: absolute;
  top: 6px;
  right: 8px;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 18px;
  cursor: pointer;
}
.debit-backend-footer {
  margin-top: 10px;
}
@media (min-width: 1200px) {
  .debit-editor-page {
    margin: -8px -24px 0;
    min-height: calc(100vh - 64px);
  }
}
.debit-modal-backdrop {
  position: fixed;
  z-index: 1500;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(20, 38, 36, 0.42);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.debit-modal {
  width: min(480px, 100%);
  padding: 22px;
  border: 1px solid var(--dn-border);
  border-radius: 14px;
  background: var(--dn-surface);
  color: var(--dn-text);
  box-shadow: 0 18px 48px rgba(14, 26, 32, 0.22);
}
.debit-modal h2 {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
}
.debit-modal-copy {
  color: var(--dn-muted);
  font-size: 13px;
  line-height: 20px;
}
.debit-modal-copy p:last-child {
  margin-bottom: 0;
}
.debit-modal-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}
@media (max-width: 1199px) {
  .debit-page {
    margin-top: 16px;
  }
  .debit-page-heading h1 {
    font-size: 28px;
    line-height: 35px;
    letter-spacing: -0.42px;
  }
  .debit-filters {
    align-items: flex-start;
    flex-direction: column;
  }
  .debit-search {
    width: 100%;
    max-width: 100%;
    flex-basis: 40px;
  }
  .debit-filter-group {
    width: 100%;
  }
  .debit-editor-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .debit-editor-topbar {
    min-height: 0;
    padding: 0;
    border-bottom: 0;
  }
  .debit-editor-actions-top {
    display: none;
  }
  .debit-editor-form {
    padding: 0;
  }
  .debit-preview-desktop {
    display: none;
  }
  .debit-preview-responsive {
    display: flex;
    min-height: 0;
    margin: 20px 0;
    padding: 16px;
    border: 1px solid var(--dn-border);
    border-radius: 10px;
    background: var(--dn-surface);
  }
  .debit-preview-mobile {
    display: none;
  }
  .debit-editor-title {
    margin: 20px 0 0;
  }
  .debit-customer-direction-hint {
    display: block;
  }
}
@media (max-width: 700px) {
  body:has(.dashboard-nav.debit-note-navigation) .dashboard-sidebar-launcher {
    display: none !important;
  }
  .debit-page {
    margin: 14px -8px 24px;
  }
  .debit-page-heading {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
    margin-bottom: 18px;
  }
  .debit-page-heading h1,
  .debit-editor-title h1 {
    font-size: 24px;
    line-height: 31px;
    letter-spacing: -0.24px;
  }
  .debit-page-heading p {
    margin: 4px 0 0;
    font-size: 13px;
    line-height: 20.2px;
  }
  .debit-page-meta {
    grid-column: 1;
    font-size: 12px;
    line-height: 16.8px;
  }
  .debit-page-actions {
    width: 100%;
    gap: 8px;
  }
  .debit-page-actions
    :is(.debit-primary-button, .note-register-create-button) {
    flex: 1 1;
  }
  .debit-filter-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .debit-search {
    height: 38px;
  }
  .debit-filter {
    width: 100%;
    height: 38px;
  }
  .debit-direction-filter {
    grid-column: 1;
  }
  .debit-status-filter {
    grid-column: 2;
  }
  .debit-date-filter {
    grid-column: 1/-1;
    width: 100%;
  }
  .debit-clear-filters {
    align-self: flex-start;
  }
  .debit-register {
    border-radius: 12px;
  }
  .debit-empty {
    min-height: 243px;
    padding: 24px 16px;
    gap: 16px;
  }
  .debit-empty h2 {
    font-size: 16px;
    line-height: 22.4px;
  }
  .debit-empty p {
    font-size: 13px;
    line-height: 20.2px;
  }
  .debit-page .debit-guidance {
    margin-top: 16px;
    font-size: 12px;
    line-height: 16.8px;
  }
  .debit-breadcrumbs {
    margin-bottom: 0;
    font-size: 12px;
    line-height: 16px;
  }
  .debit-editor-title p {
    font-size: 12px;
    line-height: 16.8px;
  }
  .debit-editor-actions {
    width: 100%;
    flex-wrap: wrap;
  }
  .debit-editor-layout {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  .debit-form-section {
    gap: 8px;
    padding: 20px 0;
  }
  .debit-form-section > label,
  .debit-form-section > h2,
  .debit-section-header h2,
  .debit-notes-label h2 {
    font-size: 13px;
    line-height: 16.9px;
  }
  .debit-form-section input,
  .debit-form-section select {
    height: 40px;
    font-size: 13px;
  }
  .debit-form-section textarea {
    font-size: 13px;
  }
  .debit-field-hint,
  .debit-section-hint {
    font-size: 12px;
    line-height: 16.8px;
  }
  .debit-direction-toggle button {
    height: 36px;
    font-size: 12px;
  }
  .debit-line-head {
    display: none;
  }
  .debit-lines-title-desktop {
    display: none;
  }
  .debit-lines-title-mobile {
    display: inline;
  }
  .debit-lines-table {
    overflow: visible;
    border: 0;
    border-radius: 0;
    background: transparent;
  }
  .debit-line-row {
    min-height: 181px;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 16px;
    grid-template-rows: 16px auto auto;
    gap: 12px;
    padding: 12px;
    border: 1px solid var(--dn-border);
    border-radius: 10px;
  }
  .debit-line-row > label {
    height: auto;
    justify-content: flex-start;
    padding: 0;
  }
  .debit-line-row + .debit-line-row {
    margin-top: 12px;
  }
  .debit-mobile-line-label {
    display: block;
    grid-column: 1/3;
    grid-row: 1;
    color: var(--dn-muted);
    font-size: 11px;
    font-weight: 500;
    line-height: 14.3px;
  }
  .debit-line-row .debit-description {
    grid-column: 1/-1;
    grid-row: 2;
  }
  .debit-line-row .debit-quantity {
    grid-column: 1;
    grid-row: 3;
  }
  .debit-line-row .debit-unit-amount {
    grid-column: 2;
    grid-row: 3;
  }
  .debit-line-row .debit-remove-line {
    grid-column: 3;
    grid-row: 1;
    width: 16px;
    height: 16px;
    align-self: start;
    border: 0;
    border-radius: 0;
    background: transparent;
  }
  .debit-remove-icon-desktop {
    display: none;
  }
  .debit-remove-icon-mobile {
    display: block;
  }
  .debit-line-row > label > span,
  .debit-line-total > span {
    display: block;
    color: var(--dn-muted);
    font-size: 13px;
    line-height: 18.2px;
  }
  .debit-line-row .debit-description input {
    height: 37px;
  }
  .debit-line-row .debit-quantity input,
  .debit-line-row .debit-unit-amount input {
    height: 34px;
    text-align: right;
  }
  .debit-line-total {
    display: none;
  }
  .debit-line-total-row {
    min-height: 45px;
    font-size: 13px;
    line-height: 16.9px;
  }
  .debit-selected-source {
    min-height: 71px;
    gap: 12px;
    padding: 12px;
  }
  .debit-selected-source span {
    max-width: 190px;
  }
  .debit-notes-label {
    flex-wrap: wrap;
  }
  .debit-preview {
    width: 100%;
    margin: 20px 0;
    padding: 16px;
  }
  .debit-preview-tablet {
    display: none;
  }
  .debit-preview-mobile {
    display: flex;
  }
  .debit-preview h2 {
    font-size: 13px;
  }
  .debit-preview-card {
    padding: 12px;
    font-size: 12px;
  }
  .debit-preview-notification {
    display: none;
  }
  .debit-editor-footer {
    padding: 14px 0;
  }
  .debit-editor-footer > p {
    font-size: 12px;
    line-height: 16.8px;
  }
  .debit-editor-actions-bottom {
    display: flex;
    flex-direction: column;
  }
  .debit-editor-footer .debit-primary-button,
  .debit-editor-footer .debit-secondary-button {
    width: 100%;
    flex: 0 0 40px;
    justify-content: center;
    padding: 0 12px;
    font-size: 13px;
  }
  .debit-backend-footer {
    font-size: 10px;
  }
  .debit-modal {
    padding: 18px;
  }
  .debit-modal h2 {
    font-size: 16px;
  }
  .debit-modal-copy {
    font-size: 12px;
  }
  .debit-modal-actions {
    justify-content: stretch;
  }
  .debit-modal-actions button {
    flex: 1 1;
    justify-content: center;
    font-size: 11px;
  }
}

.debit-tablet-nav {
  display: none;
}
.debit-tablet-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--dn-muted);
  font-size: 13px;
  font-weight: 500;
}
.debit-tablet-brand button {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border: 1px solid var(--dn-border);
  border-radius: 10px;
  background: var(--dn-soft);
  color: var(--dn-text);
  cursor: pointer;
}
.debit-tablet-brand svg {
  width: 20px;
  height: 20px;
}
.debit-organisation-wrap {
  position: relative;
  z-index: 90;
}
.debit-organisation-switcher {
  display: flex;
  width: 220px;
  min-width: 0;
  height: 62px;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
  text-align: left;
  cursor: pointer;
}
.debit-organisation-switcher:hover,
.debit-organisation-switcher[aria-expanded="true"] {
  border-color: var(--interactive-default, #0f766e);
}
.debit-organisation-avatar {
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  place-items: center;
  border: 1.5px solid var(--border-subtle, #dce3e2);
  border-radius: 16px;
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
  font-size: 12px;
  font-weight: 500;
}
.debit-organisation-copy {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 2px;
}
.debit-organisation-copy strong {
  overflow: hidden;
  font-size: 13px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.debit-organisation-copy small {
  color: var(--dn-muted);
  font-size: 11px;
  line-height: 15px;
}
.debit-organisation-switcher > svg {
  width: 16px;
  height: 16px;
  color: var(--interactive-default, #0f766e);
}
.debit-organisation-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 1350;
  display: flex;
  width: min(300px, calc(100vw - 48px));
  flex-direction: column;
  gap: 2px;
  padding: 6px;
  border: 1px solid var(--dn-border-strong);
  border-radius: 12px;
  background: var(--dn-surface);
  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.14),
    0 1px 2px rgba(14, 26, 32, 0.06);
}
.debit-organisation-menu button {
  display: flex;
  width: 100%;
  min-height: 42px;
  align-items: center;
  gap: 9px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--dn-text);
  font: 400 12px/18px var(--font-family-primary, "Lexend", sans-serif);
  text-align: left;
  cursor: pointer;
}
.debit-organisation-menu button:hover,
.debit-organisation-menu button.is-current {
  background: var(--dn-brand-soft);
  color: var(--dn-brand);
}
.debit-organisation-menu button > svg {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
}
.debit-organisation-menu button > span {
  min-width: 0;
  flex: 1 1;
}
.debit-page.dark .debit-organisation-menu button.is-current {
  color: var(--dn-brand);
}
@media (min-width: 701px) and (max-width: 1199px) {
  .debit-page {
    margin: 7px 0 32px;
  }
  .debit-tablet-nav {
    display: flex;
    height: 62px;
    align-items: center;
    justify-content: space-between;
    margin: 9px 0 42px;
  }
  .debit-editor-page .debit-tablet-nav {
    margin: 0 0 20px;
  }
  .debit-tablet-direction-title {
    display: inline;
  }
  .debit-filter-group {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    width: auto;
  }
  .debit-direction-filter {
    width: 130px;
  }
  .debit-status-filter {
    width: 112px;
  }
  .debit-date-filter {
    width: 144px;
  }
}
@media (min-width: 701px) and (max-width: 1199px) {
  .dashboard-nav.debit-note-navigation .dashboard-org-wrap {
    display: none;
  }
}
@media (max-width: 700px) {
  .debit-page {
    margin: 14px -8px 24px;
  }
  .debit-tablet-nav {
    display: flex;
    min-height: 48px;
    align-items: center;
    justify-content: flex-start;
    margin: 0 0 12px;
  }
  .debit-tablet-brand {
    display: none;
  }
  .debit-organisation-switcher {
    width: min(220px, 100%);
    height: 48px;
    padding: 0 8px;
  }
  .debit-organisation-avatar {
    width: 30px;
    height: 30px;
    flex-basis: 30px;
  }
}
.debit-tablet-brand > span {
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.debit-organisation-switcher {
  gap: 8px;
  padding: 12px;
  overflow: hidden;
}
.debit-organisation-avatar {
  border-width: 1.5px;
  font-size: 12px;
  line-height: normal;
}
.debit-organisation-copy {
  gap: 4px;
}
.debit-organisation-copy strong {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.debit-organisation-copy small {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 11px;
  font-weight: 400;
  line-height: 15.4px;
  letter-spacing: 0.11px;
}
.debit-organisation-switcher > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  stroke-width: 2;
}
@media (max-width: 700px) {
  .debit-tablet-nav {
    min-height: 58px;
  }
  .debit-organisation-wrap {
    width: 100%;
  }
  .debit-organisation-switcher {
    width: 100%;
    height: auto;
    min-height: 58px;
    padding: 12px;
  }
  .debit-organisation-avatar {
    width: 32px;
    height: 32px;
    flex-basis: 32px;
  }
}

@media (max-width: 767px) {
  .debit-line-row .debit-description {
    height: auto;
    padding: 0;
    flex-direction: column;
    align-items: stretch;
  }
  .debit-line-row .debit-description .quotation-figma-dropdown {
    flex: 0 0 auto;
    width: 100%;
  }
}

/* Preserve the editor title and its grid position while its draft is fetched. */
.debit-editor-layout.is-loading .debit-editor-form > :not(.debit-editor-title):not(.debit-editor-loading),
.debit-editor-layout.is-loading > :not(.debit-editor-form) { display: none; }
`, "",{"version":3,"sources":["webpack://./src/layouts/DebitNote/debitNote.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,4CAA4C;EAC5C,uCAAuC;EACvC,0CAA0C;EAC1C,0CAA0C;EAC1C,kDAAkD;EAClD,+CAA+C;EAC/C,iDAAiD;EACjD,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,6DAA6D;AAC/D;AACA;EACE,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,sBAAsB;AACxB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,+CAA+C;EAC/C,6CAA6C;EAC7C,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,kDAAkD;EAClD,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,+CAA+C;AACjD;AACA;;EAEE,mBAAmB;AACrB;AACA;;;EAGE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yCAAyC;EACzC,uCAAuC;EACvC,kCAAkC;AACpC;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,qBAAqB;EACrB,oEAAoE;AACtE;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;;;EAIE,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;AACf;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,6DAA6D;AAC/D;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;;EAEE,gCAAgC;EAChC,sBAAsB;AACxB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,+DAA+D;EAC/D,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,wCAAwC;EACxC,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,4CAA4C;AAC9C;AACA;;EAEE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EAGxB;aACW;AACb;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,6CAA6C;EAC7C,4CAA4C;EAC5C,uCAAuC;EACvC,0CAA0C;EAC1C,0CAA0C;EAC1C,kDAAkD;EAClD,+CAA+C;EAC/C,iDAAiD;AACnD;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,yCAAyC;AAC3C;AACA;;;;EAIE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,sEAAsE;EACtE,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;;;EAGE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,sEAAsE;AACxE;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,wEAAwE;AAC1E;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;;;;EAIE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,wEAAwE;EACxE,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;AACf;AACA;;;EAGE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iEAAiE;EACjE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,0EAA0E;EAC1E,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,0EAA0E;AAC5E;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,sEAAsE;EACtE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,6CAA6C;EAC7C,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,sBAAsB;EACtB,0EAA0E;EAC1E,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,SAAS;EACT,SAAS;EACT,sCAAsC;AACxC;AACA;EACE,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;IACpB,8BAA8B;EAChC;AACF;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,aAAa;IACb,cAAc;IACd,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qCAAqC;IACrC,SAAS;IACT,mBAAmB;EACrB;EACA;;IAEE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,QAAQ;EACV;EACA;;IAEE,SAAO;EACT;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;EACA;IACE,QAAQ;IACR,eAAe;EACjB;EACA;;;;IAIE,eAAe;IACf,mBAAmB;EACrB;EACA;;IAEE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,yDAAyD;IACzD,kCAAkC;IAClC,SAAS;IACT,aAAa;IACb,kCAAkC;IAClC,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;;IAEE,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;;IAEE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;IACd,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;;IAEE,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,SAAO;IACP,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,6CAA6C;EAC7C,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iDAAiD;EACjD,mBAAmB;EACnB,4CAA4C;EAC5C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B;oCACkC;AACpC;AACA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,oEAAoE;EACpE,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,SAAO;AACT;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,YAAY;IACZ,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA,gFAAgF;AAChF;6DAC6D,aAAa,EAAE","sourcesContent":[".debit-page {\n  --dn-bg: var(--bg-primary, #f4f7f7);\n  --dn-surface: var(--surface-primary, #fff);\n  --dn-soft: var(--surface-secondary, #f4f7f7);\n  --dn-text: var(--text-primary, #142624);\n  --dn-muted: var(--text-secondary, #506360);\n  --dn-border: var(--border-subtle, #dce3e2);\n  --dn-border-strong: var(--border-default, #cdd6d4);\n  --dn-brand: var(--interactive-default, #0f766e);\n  --dn-brand-soft: var(--interactive-soft, #f0f8f7);\n  margin: 20px 8px 32px;\n  min-width: 0;\n  background: var(--dn-bg);\n  color: var(--dn-text);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.global-dashboard-layout:has(.debit-page) {\n  min-height: 100vh;\n  background: var(--bg-primary, #f4f7f7);\n}\n.debit-page * {\n  box-sizing: border-box;\n}\n.debit-page h1,\n.debit-page h2,\n.debit-page p {\n  margin-top: 0;\n}\n.debit-page a {\n  color: inherit;\n}\n.debit-page-heading {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: 16px;\n  row-gap: 16px;\n  margin-bottom: 24px;\n}\n.debit-page-heading h1,\n.debit-editor-title h1 {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n}\n.debit-page-heading p {\n  margin: 4px 0 0;\n  color: var(--dn-muted);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.debit-page-meta,\n.debit-editor-title p {\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.debit-page-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.debit-page-meta {\n  grid-column: 1 / -1;\n}\n.debit-primary-button.MuiButton-root,\n.debit-secondary-button.MuiButton-root,\n.debit-danger-button.MuiButton-root {\n  display: inline-flex;\n  min-width: 0;\n  height: 40px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  border: 1px solid var(--dn-border-strong);\n  border-radius: 10px;\n  background: var(--dn-surface);\n  color: var(--dn-text);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n  letter-spacing: 0;\n  text-transform: none;\n  box-shadow: none;\n  white-space: nowrap;\n}\n.debit-primary-button.MuiButton-root {\n  border-color: var(--dn-brand);\n  background: var(--dn-brand);\n  color: #fff;\n}\n.debit-primary-button.MuiButton-root:not(.Mui-disabled):hover {\n  border-color: var(--interactive-hover, #0c5f59);\n  background: var(--interactive-hover, #0c5f59);\n  color: var(--on-interactive-primary, #fff);\n  box-shadow: none;\n}\n.debit-secondary-button.MuiButton-root:not(.Mui-disabled):hover {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-soft-hover, #e4f2f0);\n  color: var(--text-primary, #142624);\n  box-shadow: none;\n}\n.debit-primary-button.MuiButton-root:not(.Mui-disabled):active {\n  border-color: var(--interactive-pressed, #0a4a46);\n  background: var(--interactive-pressed, #0a4a46);\n}\n.debit-primary-button .MuiCircularProgress-root,\n.debit-secondary-button .MuiCircularProgress-root {\n  color: currentColor;\n}\n.debit-primary-button.MuiButton-root:focus-visible,\n.debit-secondary-button.MuiButton-root:focus-visible,\n.debit-danger-button.MuiButton-root:focus-visible {\n  outline: 2px solid var(--focus-ring, #41a89e);\n  outline-offset: 2px;\n}\n.debit-danger-button.MuiButton-root {\n  border-color: #b42318;\n  color: #b42318;\n}\n.debit-danger-button.MuiButton-root:not(.Mui-disabled):hover {\n  border-color: var(--danger-text, #b42318);\n  background: var(--danger-soft, #fff1f0);\n  color: var(--danger-text, #b42318);\n}\n.debit-primary-button svg,\n.debit-secondary-button svg {\n  width: 16px;\n  height: 16px;\n}\n.debit-primary-button.Mui-disabled,\n.debit-secondary-button.Mui-disabled {\n  opacity: 0.48;\n}\n.debit-filters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n.debit-search {\n  display: flex;\n  width: min(360px, 34%);\n  height: 40px;\n  flex: 0 0 min(360px, 34%);\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid var(--dn-border-strong);\n  border-radius: 10px;\n  background: var(--dn-surface);\n  color: var(--dn-muted);\n}\n.debit-search svg {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n}\n.debit-search input {\n  width: 100%;\n  min-width: 0;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--dn-text);\n  font: 400 13px/20px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.debit-search input::placeholder {\n  color: var(--dn-muted);\n  opacity: 1;\n}\n.debit-search:focus-within {\n  border-color: var(--dn-brand);\n  box-shadow: none;\n}\n.debit-page .quotation-figma-dropdown-trigger:not(:disabled):focus-visible,\n.debit-page\n  .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger {\n  border: 1px solid var(--dn-brand);\n  box-shadow: none;\n  outline: none;\n}\n.debit-page\n  .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger {\n  padding-inline: 12px 10px;\n}\n.debit-filter-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n.debit-filter {\n  height: 40px;\n  flex: 0 0 auto;\n}\n.debit-filter .quotation-figma-dropdown {\n  height: 100%;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.debit-direction-filter {\n  min-width: 130px;\n  width: auto;\n}\n.debit-status-filter {\n  min-width: 120px;\n  width: auto;\n}\n.debit-date-filter {\n  min-width: 150px;\n  width: auto;\n}\n.debit-filter .quotation-figma-dropdown-trigger {\n  height: 40px;\n  border-color: var(--dn-border-strong);\n  border-radius: 10px;\n  background: var(--dn-surface);\n  color: var(--dn-text);\n  font-size: 13px;\n}\n.debit-filter .quotation-figma-dropdown-menu {\n  z-index: 1300 !important;\n  max-height: 240px;\n  overflow-y: auto;\n  border-color: var(--dn-border);\n  background: var(--dn-surface);\n}\n.debit-filter .quotation-figma-dropdown-option {\n  color: var(--dn-text);\n  font-size: 13px;\n}\n.debit-filter .quotation-figma-dropdown-option:hover,\n.debit-filter .quotation-figma-dropdown-option.is-selected {\n  background: var(--dn-brand-soft);\n  color: var(--dn-brand);\n}\n.debit-clear-filters,\n.debit-link-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border: 0;\n  background: transparent;\n  color: var(--dn-brand);\n  font: 500 13px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.debit-clear-filters svg {\n  width: 14px;\n  height: 14px;\n}\n.debit-clear-filters:not(:disabled):hover,\n.debit-link-button:not(:disabled):hover,\n.debit-add-line:not(:disabled):hover {\n  color: var(--interactive-hover, #0c5f59);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n.debit-register {\n  overflow: hidden;\n  border: 1px solid var(--dn-border);\n  border-radius: 14px;\n  background: var(--dn-surface);\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.debit-register-loading-summary,\n.debit-register-loading-footer {\n  display: flex;\n  min-height: 36px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 0 16px;\n  background: var(--dn-surface);\n}\n.debit-register-table-scroll {\n  overflow-x: auto;\n}\n.debit-register-table {\n  width: 100%;\n  min-width: 920px;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n.debit-register-table th {\n  height: 36px;\n  padding: 0 8px;\n  background: var(--dn-soft);\n  color: var(--dn-muted);\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14.3px;\n  letter-spacing: 0.11px;\n  text-align: left;\n}\n.debit-register-table th:first-child {\n  width: 15%;\n  padding-left: 16px;\n}\n.debit-register-table th:nth-child(2) {\n  width: 9%;\n}\n.debit-register-table th:nth-child(3) {\n  width: 16%;\n}\n.debit-register-table th:nth-child(4) {\n  width: 13%;\n}\n.debit-register-table th:nth-child(5) {\n  width: 13%;\n}\n.debit-register-table th:nth-child(6) {\n  width: 10%;\n}\n.debit-register-table th:nth-child(7) {\n  width: 7%;\n}\n.debit-register-table th:nth-child(8) {\n  width: 10%;\n}\n.debit-register-table th:nth-child(9) {\n  width: 7%;\n}\n.debit-register-table td {\n  height: 64px;\n  padding: 0 8px;\n  border-bottom: 1px solid var(--dn-border);\n}\n.debit-register-table td:first-child {\n  padding-left: 16px;\n}\n.debit-register-table .debit-register-amount {\n  text-align: right;\n}\n.debit-register-table .debit-register-actions {\n  text-align: center;\n}\n.debit-register-loading-footer {\n  min-height: 52px;\n  border-top: 1px solid var(--dn-border);\n}\n.debit-register-loading-footer > div {\n  display: flex;\n  gap: 8px;\n}\n.debit-empty {\n  display: flex;\n  min-height: 243px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 32px;\n  text-align: center;\n}\n.debit-empty-icon {\n  display: block;\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  color: var(--dn-muted);\n  background: currentColor;\n  -webkit-mask: url(\"../../assets/icons/debit-note-empty.svg\") center / contain\n    no-repeat;\n  mask: url(\"../../assets/icons/debit-note-empty.svg\") center / contain\n    no-repeat;\n}\n.debit-empty h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22.4px;\n  letter-spacing: -0.08px;\n}\n.debit-empty p {\n  max-width: 520px;\n  margin: 0;\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.debit-empty-action {\n  margin-top: 0;\n}\n.debit-no-results {\n  display: flex;\n  min-height: 185px;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 8px;\n  margin: 24px;\n  padding: 16px;\n  border: 1px solid var(--dn-border);\n  border-radius: 10px;\n  background: var(--dn-soft);\n}\n.debit-no-results h2 {\n  margin: 0;\n  color: var(--dn-muted);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20.2px;\n}\n.debit-no-results p {\n  margin: 0;\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.debit-page .debit-guidance {\n  margin: 24px 0 0;\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.debit-inline-notice {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: -8px 0 16px;\n  padding: 12px 16px;\n  border: 1px solid var(--dn-border);\n  border-radius: 10px;\n  background: var(--dn-brand-soft);\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.debit-inline-notice button {\n  border: 0;\n  background: transparent;\n  color: var(--dn-text);\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n.debit-page.dark {\n  --dn-bg: var(--bg-primary, #101113);\n  --dn-surface: var(--surface-primary, #191b1f);\n  --dn-soft: var(--surface-secondary, #22252a);\n  --dn-text: var(--text-primary, #f2f3f5);\n  --dn-muted: var(--text-secondary, #b3b8c2);\n  --dn-border: var(--border-subtle, #2c3036);\n  --dn-border-strong: var(--border-default, #3a3f47);\n  --dn-brand: var(--interactive-default, #43a79c);\n  --dn-brand-soft: var(--interactive-soft, #22252a);\n}\n.debit-page.dark .debit-primary-button.MuiButton-root {\n  color: #10201e;\n}\n.debit-page.dark .debit-danger-button.MuiButton-root {\n  color: #f97066;\n}\n.debit-page .quotation-figma-dropdown {\n  position: relative;\n}\n.debit-page .quotation-figma-dropdown.is-open {\n  z-index: 1300;\n}\n.debit-page .quotation-figma-dropdown-trigger {\n  border-color: var(--dn-border-strong);\n  border-radius: 10px;\n  background: var(--dn-surface);\n  color: var(--dn-text);\n}\n.debit-page .quotation-figma-dropdown-menu {\n  z-index: 1300 !important;\n  max-height: 240px;\n  overflow-y: auto;\n  border-color: var(--dn-border);\n  background: var(--dn-surface);\n}\n.debit-page .quotation-figma-dropdown-option {\n  color: var(--dn-text);\n}\n.debit-page .quotation-figma-dropdown-option:hover,\n.debit-page .quotation-figma-dropdown-option.is-selected {\n  background: var(--dn-brand-soft);\n  color: var(--dn-brand);\n}\n.debit-breadcrumbs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  color: var(--dn-muted);\n  font-size: 12px;\n  line-height: 18px;\n}\n.debit-breadcrumbs svg {\n  width: 14px;\n  height: 14px;\n}\n.debit-breadcrumbs a {\n  text-decoration: none;\n}\n.debit-breadcrumbs a:hover {\n  color: var(--dn-brand);\n}\n.debit-breadcrumbs span {\n  color: var(--dn-text);\n  font-weight: 500;\n}\n.debit-editor-topbar {\n  display: flex;\n  min-height: 72px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 0 32px;\n  border-bottom: 1px solid var(--dn-border);\n}\n.debit-editor-title {\n  margin-bottom: 20px;\n}\n.debit-editor-title h1 {\n  font-size: 24px;\n  line-height: 30px;\n  letter-spacing: -0.36px;\n}\n.debit-editor-title p {\n  margin: 4px 0 0;\n}\n.debit-editor-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.debit-editor-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 360px;\n  align-items: start;\n  gap: 0;\n}\n.debit-editor-form {\n  min-width: 0;\n  padding: 32px 24px 32px 32px;\n}\n.debit-form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 20px 0;\n  border-bottom: 1px solid var(--dn-border);\n}\n.debit-form-section > label,\n.debit-form-section > h2,\n.debit-section-header h2,\n.debit-notes-label h2 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.debit-form-section input,\n.debit-form-section select,\n.debit-form-section textarea {\n  width: 100%;\n  min-width: 0;\n  border: 1px solid var(--dn-border-strong);\n  border-radius: 10px;\n  background: var(--dn-surface);\n  color: var(--dn-text);\n  font: 400 13px/20.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  outline: none;\n}\n.debit-form-section input,\n.debit-form-section select {\n  height: 40px;\n  padding: 0 12px;\n}\n.debit-form-section textarea {\n  min-height: 80px;\n  padding: 12px;\n  resize: vertical;\n}\n.debit-form-section input:focus,\n.debit-form-section select:focus,\n.debit-form-section textarea:focus {\n  border-color: var(--dn-brand);\n  box-shadow: none;\n}\n.debit-form-section input:disabled {\n  background: transparent;\n  color: var(--dn-muted);\n  cursor: not-allowed;\n}\n.debit-source-select-wrap {\n  position: relative;\n  color: var(--dn-muted);\n}\n.debit-source-select-wrap > svg {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 2;\n  width: 16px;\n  height: 16px;\n  pointer-events: none;\n}\n.debit-source-select .quotation-figma-dropdown-trigger {\n  height: 40px;\n  padding-left: 36px;\n  border-color: var(--dn-border-strong);\n  border-radius: 10px;\n  background: var(--dn-surface);\n  color: var(--dn-text);\n  font: 400 13px/20.2px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.debit-source-select .quotation-figma-dropdown-trigger:disabled {\n  background: var(--dn-soft);\n  color: var(--dn-muted);\n  opacity: 1;\n}\n.debit-source-select .quotation-figma-dropdown-menu {\n  max-height: 224px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n  border-color: var(--dn-border);\n  background: var(--dn-surface);\n}\n.debit-source-select .quotation-figma-dropdown-menu::-webkit-scrollbar {\n  width: 6px;\n}\n.debit-source-select .quotation-figma-dropdown-menu::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: var(--dn-border-strong);\n}\n.debit-selected-source {\n  display: flex;\n  min-height: 74px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 12px 16px;\n  border: 1px solid var(--dn-border);\n  border-radius: 10px;\n  background: var(--dn-brand-soft);\n}\n.debit-selected-source > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 4px;\n}\n.debit-selected-source > div:last-child {\n  align-items: flex-end;\n  text-align: right;\n}\n.debit-selected-source strong {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--dn-brand);\n  font: 500 13px/18px var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.debit-selected-source strong svg {\n  width: 16px;\n  height: 16px;\n}\n.debit-selected-source span {\n  overflow: hidden;\n  color: var(--dn-muted);\n  font-size: 12px;\n  line-height: 17px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.debit-field-hint {\n  margin: 0;\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.debit-field-error {\n  color: #b42318;\n  font-size: 11px;\n  line-height: 16px;\n}\n.debit-page.dark .debit-field-error {\n  color: #f97066;\n}\n.debit-source-unavailable,\n.debit-info-note,\n.debit-backend-notice,\n.debit-backend-footer {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px;\n  border: 1px solid #d8e3f0;\n  border-radius: 10px;\n  background: #eff6ff;\n  color: #3f556c;\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.debit-source-unavailable svg,\n.debit-info-note svg,\n.debit-backend-notice svg,\n.debit-backend-footer svg {\n  width: 15px;\n  height: 15px;\n  flex: 0 0 15px;\n}\n.debit-page.dark .debit-source-unavailable,\n.debit-page.dark .debit-info-note,\n.debit-page.dark .debit-backend-notice,\n.debit-page.dark .debit-backend-footer {\n  border-color: #2d3d50;\n  background: #202d3d;\n  color: #bcc9d8;\n}\n.debit-direction-toggle {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px;\n  padding: 3px;\n  border: 1px solid var(--dn-border);\n  border-radius: 10px;\n  background: var(--dn-soft);\n}\n.debit-direction-toggle button {\n  height: 36px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--dn-muted);\n  font: 500 13px / normal var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.debit-direction-toggle button.is-active {\n  background: var(--dn-brand);\n  color: #fff;\n}\n.debit-page.dark .debit-direction-toggle button.is-active {\n  color: #10201e;\n}\n.debit-section-hint {\n  margin: 0;\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.debit-customer-direction-hint {\n  display: none;\n}\n.debit-lines-section {\n  gap: 12px;\n}\n.debit-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.debit-lines-title-mobile {\n  display: none;\n}\n.debit-lines-table {\n  overflow: visible;\n  border: 1px solid var(--dn-border);\n  border-radius: 10px;\n  background: var(--dn-surface);\n}\n.debit-line-head,\n.debit-line-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 72px 120px 120px 80px;\n  align-items: center;\n}\n.debit-line-head {\n  min-height: 32px;\n  color: var(--dn-muted);\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14.3px;\n  letter-spacing: 0.11px;\n}\n.debit-line-head span {\n  height: 32px;\n  padding: 8px 12px;\n}\n.debit-line-head span:nth-child(3),\n.debit-line-head span:nth-child(4) {\n  text-align: right;\n}\n.debit-line-head span:last-child {\n  text-align: center;\n}\n.debit-line-row {\n  position: relative;\n  min-height: 56px;\n  border-top: 1px solid var(--dn-border);\n  background: var(--dn-surface);\n}\n.debit-line-row:has(.quotation-figma-dropdown.is-open) {\n  z-index: 1250;\n}\n.debit-line-row > label {\n  display: flex;\n  height: 56px;\n  min-width: 0;\n  flex-direction: column;\n  justify-content: center;\n  gap: 4px;\n  padding: 12px;\n}\n.debit-line-row > label > span,\n.debit-line-total > span,\n.debit-mobile-line-label {\n  display: none;\n}\n.debit-line-row .debit-description {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  height: 56px;\n  padding: 8px 12px;\n}\n.debit-line-row .debit-description input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 36px;\n}\n.debit-line-row .debit-description .quotation-figma-dropdown {\n  flex: 0 0 152px;\n  width: 152px;\n}\n.debit-line-row .debit-description .quotation-figma-dropdown-trigger {\n  height: 36px;\n  padding: 0 8px;\n  border-radius: 6px;\n  border-color: var(--dn-border);\n  background: var(--dn-surface);\n  color: var(--dn-text);\n  font-size: 12px;\n}\n.debit-line-row .debit-description .quotation-figma-dropdown-trigger svg {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 14px;\n}\n.debit-line-row .debit-description .quotation-figma-dropdown-menu {\n  z-index: 1300 !important;\n  max-height: 200px;\n  overflow-y: auto;\n}\n.debit-line-row .debit-quantity input,\n.debit-line-row .debit-unit-amount input {\n  height: 32px;\n  padding: 0 8px;\n  text-align: center;\n}\n.debit-line-row .debit-unit-amount input {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-weight: 500;\n  text-align: right;\n}\n.debit-line-total {\n  display: flex;\n  height: 56px;\n  min-width: 0;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 12px;\n  color: var(--dn-muted);\n  font-size: 13px;\n}\n.debit-line-total strong {\n  display: flex;\n  width: 96px;\n  height: 32px;\n  align-items: center;\n  justify-content: flex-end;\n  overflow: hidden;\n  padding: 0 10px;\n  border-radius: 10px;\n  background: var(--dn-soft);\n  color: var(--dn-muted);\n  font: 500 16px/20.8px var(--font-family-mono, \"JetBrains Mono\", monospace);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.debit-remove-line {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  justify-self: center;\n  place-items: center;\n  border: 1px solid var(--dn-border);\n  border-radius: 10px;\n  background: var(--dn-surface);\n  color: var(--dn-muted);\n  cursor: pointer;\n}\n.debit-remove-line:hover {\n  border-color: #d92d20;\n  color: #d92d20;\n}\n.debit-remove-line:disabled {\n  border-color: var(--dn-border);\n  background: var(--dn-soft);\n  color: var(--dn-muted);\n  cursor: not-allowed;\n  opacity: 0.48;\n}\n.debit-remove-line svg {\n  width: 15px;\n  height: 15px;\n}\n.debit-remove-icon-mobile {\n  display: none;\n}\n.debit-line-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 48px;\n  padding: 12px;\n  border: 1px solid var(--dn-border);\n  border-radius: 10px;\n  background: var(--dn-surface);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15.6px;\n  letter-spacing: 0.12px;\n  color: var(--dn-muted);\n}\n.debit-line-total-row strong {\n  color: var(--dn-text);\n  font: 500 16px/20.8px var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.debit-add-line {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  align-self: flex-start;\n  padding: 8px 4px;\n  border: 0;\n  background: transparent;\n  color: var(--dn-brand);\n  font: 500 12px/15.6px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.12px;\n  cursor: pointer;\n}\n.debit-add-line svg {\n  width: 14px;\n  height: 14px;\n}\n.debit-add-line:focus-visible,\n.debit-clear-filters:focus-visible,\n.debit-link-button:focus-visible {\n  outline: 2px solid var(--focus-ring, #41a89e);\n  outline-offset: 2px;\n  border-radius: var(--radius-sm, 6px);\n}\n.debit-notes-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.debit-notes-label > span {\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--dn-muted);\n  font-size: 11px;\n  line-height: 15.4px;\n  letter-spacing: 0.11px;\n}\n.debit-preview {\n  display: flex;\n  min-height: 100%;\n  flex-direction: column;\n  gap: 20px;\n  padding: 32px 24px;\n  border-left: 1px solid var(--dn-border);\n  background: var(--dn-soft);\n}\n.debit-preview h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n}\n.debit-preview > p {\n  margin: -16px 0 0;\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.debit-preview-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  border: 1px solid var(--dn-border);\n  border-radius: 10px;\n  background: var(--dn-surface);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.debit-preview-card strong {\n  color: var(--dn-brand);\n  font: 500 14px/18.2px var(--font-family-mono, \"JetBrains Mono\", monospace);\n  letter-spacing: 0.28px;\n}\n.debit-preview-card span {\n  color: var(--dn-muted);\n}\n.debit-preview-source-card strong {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.debit-preview-source-card strong svg {\n  width: 16px;\n  height: 16px;\n}\n.debit-preview-source-card b {\n  color: var(--dn-text);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18.2px;\n}\n.debit-preview-breakdown {\n  gap: 12px;\n}\n.debit-preview-breakdown > div {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n.debit-preview-breakdown > div > strong {\n  flex: 0 0 auto;\n  color: var(--dn-text);\n  font-size: 13px;\n}\n.debit-preview-breakdown hr {\n  width: 100%;\n  margin: 0;\n  border: 0;\n  border-top: 1px solid var(--dn-border);\n}\n.debit-preview-breakdown .debit-preview-projected {\n  flex-direction: column;\n  gap: 4px;\n}\n.debit-preview-breakdown .debit-preview-projected strong {\n  color: var(--dn-brand);\n  font-size: 16px;\n  line-height: 21px;\n}\n.debit-preview-callout {\n  flex-direction: row;\n  align-items: flex-start;\n  color: var(--dn-muted);\n}\n.debit-preview-callout svg {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 14px;\n}\n.debit-preview-responsive {\n  display: none;\n}\n.debit-tablet-direction-title {\n  display: none;\n}\n.debit-editor-footer {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 16px 0;\n}\n.debit-editor-footer > p {\n  margin: 0;\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.debit-backend-notice {\n  position: relative;\n  margin: 0 0 16px;\n  padding-right: 38px;\n}\n.debit-backend-notice button {\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font-size: 18px;\n  cursor: pointer;\n}\n.debit-backend-footer {\n  margin-top: 10px;\n}\n@media (min-width: 1200px) {\n  .debit-editor-page {\n    margin: -8px -24px 0;\n    min-height: calc(100vh - 64px);\n  }\n}\n.debit-modal-backdrop {\n  position: fixed;\n  z-index: 1500;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  background: rgba(20, 38, 36, 0.42);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n.debit-modal {\n  width: min(480px, 100%);\n  padding: 22px;\n  border: 1px solid var(--dn-border);\n  border-radius: 14px;\n  background: var(--dn-surface);\n  color: var(--dn-text);\n  box-shadow: 0 18px 48px rgba(14, 26, 32, 0.22);\n}\n.debit-modal h2 {\n  margin: 0 0 12px;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 26px;\n}\n.debit-modal-copy {\n  color: var(--dn-muted);\n  font-size: 13px;\n  line-height: 20px;\n}\n.debit-modal-copy p:last-child {\n  margin-bottom: 0;\n}\n.debit-modal-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 20px;\n}\n@media (max-width: 1199px) {\n  .debit-page {\n    margin-top: 16px;\n  }\n  .debit-page-heading h1 {\n    font-size: 28px;\n    line-height: 35px;\n    letter-spacing: -0.42px;\n  }\n  .debit-filters {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .debit-search {\n    width: 100%;\n    max-width: 100%;\n    flex-basis: 40px;\n  }\n  .debit-filter-group {\n    width: 100%;\n  }\n  .debit-editor-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .debit-editor-topbar {\n    min-height: 0;\n    padding: 0;\n    border-bottom: 0;\n  }\n  .debit-editor-actions-top {\n    display: none;\n  }\n  .debit-editor-form {\n    padding: 0;\n  }\n  .debit-preview-desktop {\n    display: none;\n  }\n  .debit-preview-responsive {\n    display: flex;\n    min-height: 0;\n    margin: 20px 0;\n    padding: 16px;\n    border: 1px solid var(--dn-border);\n    border-radius: 10px;\n    background: var(--dn-surface);\n  }\n  .debit-preview-mobile {\n    display: none;\n  }\n  .debit-editor-title {\n    margin: 20px 0 0;\n  }\n  .debit-customer-direction-hint {\n    display: block;\n  }\n}\n@media (max-width: 700px) {\n  body:has(.dashboard-nav.debit-note-navigation) .dashboard-sidebar-launcher {\n    display: none !important;\n  }\n  .debit-page {\n    margin: 14px -8px 24px;\n  }\n  .debit-page-heading {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 16px;\n    margin-bottom: 18px;\n  }\n  .debit-page-heading h1,\n  .debit-editor-title h1 {\n    font-size: 24px;\n    line-height: 31px;\n    letter-spacing: -0.24px;\n  }\n  .debit-page-heading p {\n    margin: 4px 0 0;\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .debit-page-meta {\n    grid-column: 1;\n    font-size: 12px;\n    line-height: 16.8px;\n  }\n  .debit-page-actions {\n    width: 100%;\n    gap: 8px;\n  }\n  .debit-page-actions\n    :is(.debit-primary-button, .note-register-create-button) {\n    flex: 1;\n  }\n  .debit-filter-group {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n  }\n  .debit-search {\n    height: 38px;\n  }\n  .debit-filter {\n    width: 100%;\n    height: 38px;\n  }\n  .debit-direction-filter {\n    grid-column: 1;\n  }\n  .debit-status-filter {\n    grid-column: 2;\n  }\n  .debit-date-filter {\n    grid-column: 1/-1;\n    width: 100%;\n  }\n  .debit-clear-filters {\n    align-self: flex-start;\n  }\n  .debit-register {\n    border-radius: 12px;\n  }\n  .debit-empty {\n    min-height: 243px;\n    padding: 24px 16px;\n    gap: 16px;\n  }\n  .debit-empty h2 {\n    font-size: 16px;\n    line-height: 22.4px;\n  }\n  .debit-empty p {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .debit-page .debit-guidance {\n    margin-top: 16px;\n    font-size: 12px;\n    line-height: 16.8px;\n  }\n  .debit-breadcrumbs {\n    margin-bottom: 0;\n    font-size: 12px;\n    line-height: 16px;\n  }\n  .debit-editor-title p {\n    font-size: 12px;\n    line-height: 16.8px;\n  }\n  .debit-editor-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n  .debit-editor-layout {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n  .debit-form-section {\n    gap: 8px;\n    padding: 20px 0;\n  }\n  .debit-form-section > label,\n  .debit-form-section > h2,\n  .debit-section-header h2,\n  .debit-notes-label h2 {\n    font-size: 13px;\n    line-height: 16.9px;\n  }\n  .debit-form-section input,\n  .debit-form-section select {\n    height: 40px;\n    font-size: 13px;\n  }\n  .debit-form-section textarea {\n    font-size: 13px;\n  }\n  .debit-field-hint,\n  .debit-section-hint {\n    font-size: 12px;\n    line-height: 16.8px;\n  }\n  .debit-direction-toggle button {\n    height: 36px;\n    font-size: 12px;\n  }\n  .debit-line-head {\n    display: none;\n  }\n  .debit-lines-title-desktop {\n    display: none;\n  }\n  .debit-lines-title-mobile {\n    display: inline;\n  }\n  .debit-lines-table {\n    overflow: visible;\n    border: 0;\n    border-radius: 0;\n    background: transparent;\n  }\n  .debit-line-row {\n    min-height: 181px;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 16px;\n    grid-template-rows: 16px auto auto;\n    gap: 12px;\n    padding: 12px;\n    border: 1px solid var(--dn-border);\n    border-radius: 10px;\n  }\n  .debit-line-row > label {\n    height: auto;\n    justify-content: flex-start;\n    padding: 0;\n  }\n  .debit-line-row + .debit-line-row {\n    margin-top: 12px;\n  }\n  .debit-mobile-line-label {\n    display: block;\n    grid-column: 1/3;\n    grid-row: 1;\n    color: var(--dn-muted);\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 14.3px;\n  }\n  .debit-line-row .debit-description {\n    grid-column: 1/-1;\n    grid-row: 2;\n  }\n  .debit-line-row .debit-quantity {\n    grid-column: 1;\n    grid-row: 3;\n  }\n  .debit-line-row .debit-unit-amount {\n    grid-column: 2;\n    grid-row: 3;\n  }\n  .debit-line-row .debit-remove-line {\n    grid-column: 3;\n    grid-row: 1;\n    width: 16px;\n    height: 16px;\n    align-self: start;\n    border: 0;\n    border-radius: 0;\n    background: transparent;\n  }\n  .debit-remove-icon-desktop {\n    display: none;\n  }\n  .debit-remove-icon-mobile {\n    display: block;\n  }\n  .debit-line-row > label > span,\n  .debit-line-total > span {\n    display: block;\n    color: var(--dn-muted);\n    font-size: 13px;\n    line-height: 18.2px;\n  }\n  .debit-line-row .debit-description input {\n    height: 37px;\n  }\n  .debit-line-row .debit-quantity input,\n  .debit-line-row .debit-unit-amount input {\n    height: 34px;\n    text-align: right;\n  }\n  .debit-line-total {\n    display: none;\n  }\n  .debit-line-total-row {\n    min-height: 45px;\n    font-size: 13px;\n    line-height: 16.9px;\n  }\n  .debit-selected-source {\n    min-height: 71px;\n    gap: 12px;\n    padding: 12px;\n  }\n  .debit-selected-source span {\n    max-width: 190px;\n  }\n  .debit-notes-label {\n    flex-wrap: wrap;\n  }\n  .debit-preview {\n    width: 100%;\n    margin: 20px 0;\n    padding: 16px;\n  }\n  .debit-preview-tablet {\n    display: none;\n  }\n  .debit-preview-mobile {\n    display: flex;\n  }\n  .debit-preview h2 {\n    font-size: 13px;\n  }\n  .debit-preview-card {\n    padding: 12px;\n    font-size: 12px;\n  }\n  .debit-preview-notification {\n    display: none;\n  }\n  .debit-editor-footer {\n    padding: 14px 0;\n  }\n  .debit-editor-footer > p {\n    font-size: 12px;\n    line-height: 16.8px;\n  }\n  .debit-editor-actions-bottom {\n    display: flex;\n    flex-direction: column;\n  }\n  .debit-editor-footer .debit-primary-button,\n  .debit-editor-footer .debit-secondary-button {\n    width: 100%;\n    flex: 0 0 40px;\n    justify-content: center;\n    padding: 0 12px;\n    font-size: 13px;\n  }\n  .debit-backend-footer {\n    font-size: 10px;\n  }\n  .debit-modal {\n    padding: 18px;\n  }\n  .debit-modal h2 {\n    font-size: 16px;\n  }\n  .debit-modal-copy {\n    font-size: 12px;\n  }\n  .debit-modal-actions {\n    justify-content: stretch;\n  }\n  .debit-modal-actions button {\n    flex: 1;\n    justify-content: center;\n    font-size: 11px;\n  }\n}\n\n.debit-tablet-nav {\n  display: none;\n}\n.debit-tablet-brand {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--dn-muted);\n  font-size: 13px;\n  font-weight: 500;\n}\n.debit-tablet-brand button {\n  display: grid;\n  width: 44px;\n  height: 44px;\n  place-items: center;\n  border: 1px solid var(--dn-border);\n  border-radius: 10px;\n  background: var(--dn-soft);\n  color: var(--dn-text);\n  cursor: pointer;\n}\n.debit-tablet-brand svg {\n  width: 20px;\n  height: 20px;\n}\n.debit-organisation-wrap {\n  position: relative;\n  z-index: 90;\n}\n.debit-organisation-switcher {\n  display: flex;\n  width: 220px;\n  min-width: 0;\n  height: 62px;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  text-align: left;\n  cursor: pointer;\n}\n.debit-organisation-switcher:hover,\n.debit-organisation-switcher[aria-expanded=\"true\"] {\n  border-color: var(--interactive-default, #0f766e);\n}\n.debit-organisation-avatar {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  place-items: center;\n  border: 1.5px solid var(--border-subtle, #dce3e2);\n  border-radius: 16px;\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n  font-size: 12px;\n  font-weight: 500;\n}\n.debit-organisation-copy {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n}\n.debit-organisation-copy strong {\n  overflow: hidden;\n  font-size: 13px;\n  font-weight: 500;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.debit-organisation-copy small {\n  color: var(--dn-muted);\n  font-size: 11px;\n  line-height: 15px;\n}\n.debit-organisation-switcher > svg {\n  width: 16px;\n  height: 16px;\n  color: var(--interactive-default, #0f766e);\n}\n.debit-organisation-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 1350;\n  display: flex;\n  width: min(300px, calc(100vw - 48px));\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px;\n  border: 1px solid var(--dn-border-strong);\n  border-radius: 12px;\n  background: var(--dn-surface);\n  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.14),\n    0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.debit-organisation-menu button {\n  display: flex;\n  width: 100%;\n  min-height: 42px;\n  align-items: center;\n  gap: 9px;\n  padding: 0 10px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--dn-text);\n  font: 400 12px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n  text-align: left;\n  cursor: pointer;\n}\n.debit-organisation-menu button:hover,\n.debit-organisation-menu button.is-current {\n  background: var(--dn-brand-soft);\n  color: var(--dn-brand);\n}\n.debit-organisation-menu button > svg {\n  width: 17px;\n  height: 17px;\n  flex: 0 0 17px;\n}\n.debit-organisation-menu button > span {\n  min-width: 0;\n  flex: 1;\n}\n.debit-page.dark .debit-organisation-menu button.is-current {\n  color: var(--dn-brand);\n}\n@media (min-width: 701px) and (max-width: 1199px) {\n  .debit-page {\n    margin: 7px 0 32px;\n  }\n  .debit-tablet-nav {\n    display: flex;\n    height: 62px;\n    align-items: center;\n    justify-content: space-between;\n    margin: 9px 0 42px;\n  }\n  .debit-editor-page .debit-tablet-nav {\n    margin: 0 0 20px;\n  }\n  .debit-tablet-direction-title {\n    display: inline;\n  }\n  .debit-filter-group {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    width: auto;\n  }\n  .debit-direction-filter {\n    width: 130px;\n  }\n  .debit-status-filter {\n    width: 112px;\n  }\n  .debit-date-filter {\n    width: 144px;\n  }\n}\n@media (min-width: 701px) and (max-width: 1199px) {\n  .dashboard-nav.debit-note-navigation .dashboard-org-wrap {\n    display: none;\n  }\n}\n@media (max-width: 700px) {\n  .debit-page {\n    margin: 14px -8px 24px;\n  }\n  .debit-tablet-nav {\n    display: flex;\n    min-height: 48px;\n    align-items: center;\n    justify-content: flex-start;\n    margin: 0 0 12px;\n  }\n  .debit-tablet-brand {\n    display: none;\n  }\n  .debit-organisation-switcher {\n    width: min(220px, 100%);\n    height: 48px;\n    padding: 0 8px;\n  }\n  .debit-organisation-avatar {\n    width: 30px;\n    height: 30px;\n    flex-basis: 30px;\n  }\n}\n.debit-tablet-brand > span {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.debit-organisation-switcher {\n  gap: 8px;\n  padding: 12px;\n  overflow: hidden;\n}\n.debit-organisation-avatar {\n  border-width: 1.5px;\n  font-size: 12px;\n  line-height: normal;\n}\n.debit-organisation-copy {\n  gap: 4px;\n}\n.debit-organisation-copy strong {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.debit-organisation-copy small {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 15.4px;\n  letter-spacing: 0.11px;\n}\n.debit-organisation-switcher > svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  stroke-width: 2;\n}\n@media (max-width: 700px) {\n  .debit-tablet-nav {\n    min-height: 58px;\n  }\n  .debit-organisation-wrap {\n    width: 100%;\n  }\n  .debit-organisation-switcher {\n    width: 100%;\n    height: auto;\n    min-height: 58px;\n    padding: 12px;\n  }\n  .debit-organisation-avatar {\n    width: 32px;\n    height: 32px;\n    flex-basis: 32px;\n  }\n}\n\n@media (max-width: 767px) {\n  .debit-line-row .debit-description {\n    height: auto;\n    padding: 0;\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .debit-line-row .debit-description .quotation-figma-dropdown {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n}\n\n/* Preserve the editor title and its grid position while its draft is fetched. */\n.debit-editor-layout.is-loading .debit-editor-form > :not(.debit-editor-title):not(.debit-editor-loading),\n.debit-editor-layout.is-loading > :not(.debit-editor-form) { display: none; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
